<template>
  <div class="chart-grid">
    <DashboardPanel
      class="chart-card"
      title="Sales & Purchase"
      subtitle="Revenue collected vs amount spent on stock."
      icon="shopping-cart"
    >
      <template #actions>
        <div class="range-tabs">
          <button v-for="range in ranges" :key="range" :class="{ active: range === selectedRange }">{{ range }}</button>
        </div>
      </template>
      <div class="chart-summary">
        <span><i></i>Total Purchase <strong>{{ compactCurrency(purchaseTotal) }}</strong></span>
        <span><i class="sales-dot"></i>Total Sales <strong>{{ compactCurrency(salesTotal) }}</strong></span>
      </div>
      <apexchart type="bar" height="320" :options="salesPurchaseOptions" :series="salesPurchaseSeries" />
    </DashboardPanel>

    <DashboardPanel
      class="chart-card"
      title="Sales Statics"
      subtitle="Revenue and expense movement across the year."
      icon="alert-triangle"
      icon-tone="danger"
    >
      <template #actions>
        <button class="year-btn"><vue-feather type="calendar" class="btn-feather"></vue-feather> 2026</button>
      </template>
      <div class="stat-summary">
        <div>
          <strong class="success-text">{{ formatCurrency(monthRevenue) }}</strong>
          <span>Revenue</span>
        </div>
        <div>
          <strong class="danger-text">{{ formatCurrency(monthExpense) }}</strong>
          <span>Expense</span>
        </div>
      </div>
      <apexchart type="bar" height="320" :options="profitTrendOptions" :series="profitTrendSeries" />
    </DashboardPanel>
  </div>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";
import { columnChartOptions, salesPurchaseChartOptions } from "../dashboardCharts";
import { compactCurrency, formatCurrency } from "@/utils/formatters";

const sum = (values) => values.reduce((total, value) => total + Number(value || 0), 0);

// Sales vs purchases, and revenue vs expense trend.
export default {
  name: "TrendSection",
  components: { DashboardPanel },
  props: {
    salesVsPurchases: { type: Object, required: true },
    profitTrend: { type: Object, required: true },
    profitSummary: { type: Object, required: true },
    // Fallback for this month's expense when the profit summary has no cost figure.
    purchasesMonth: { type: Number, default: 0 },
  },
  data() {
    // Range buttons are display-only for now (the chart always shows the last year).
    return { ranges: ["1D", "1W", "1M", "3M", "6M", "1Y"], selectedRange: "1Y" };
  },
  computed: {
    salesTotal() {
      return sum(this.salesVsPurchases.sales);
    },
    purchaseTotal() {
      return sum(this.salesVsPurchases.purchases);
    },
    monthRevenue() {
      return this.profitSummary.revenue_month || this.salesTotal;
    },
    monthExpense() {
      return this.profitSummary.cost_month || this.purchasesMonth;
    },
    salesPurchaseSeries() {
      return [
        { name: "Purchases", data: this.salesVsPurchases.purchases },
        { name: "Sales", data: this.salesVsPurchases.sales },
      ];
    },
    salesPurchaseOptions() {
      return salesPurchaseChartOptions(this.salesVsPurchases.months);
    },
    profitTrendSeries() {
      return [
        { name: "Revenue", data: this.profitTrend.revenue || [] },
        { name: "Expense", data: (this.profitTrend.cost || []).map((value) => Math.abs(Number(value || 0))) },
      ];
    },
    profitTrendOptions() {
      return columnChartOptions({
        categories: this.profitTrend.months,
        colors: ["#16a085", "#ef6c3e"],
        borderRadius: 7,
        columnWidth: "44%",
        yearLong: true,
        legend: true,
      });
    },
  },
  methods: { compactCurrency, formatCurrency },
};
</script>
